// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2JX3m","headline-wrapper":"_1h27b","prega-headline-wrapper":"mUWTs","powered-by-whatsapp":"_3XEYi","powered-by-prega":"_3Chic","story-list":"_3M8Dc","summary":"_3sqJb"};